/* eslint-disable no-undef */
function pushInteractionEvent(type, context, label) {
  dataLayer.push({
    event: 'interactions',
    eventTimestamp: Date.now(),
    type,
    context: context || '',
    label: (label || '').trim(),
  });
}

function trackButton(button) {
  button.addEventListener('click', () => {
    pushInteractionEvent('Button', button.dataset.layerContext, button.innerText);
  });
}

function trackImage(image) {
  if (!image.closest('a')) {
    return;
  }

  image.addEventListener('click', () => {
    const linkedButton = image.closest('[data-layer-type="button"]');

    if (linkedButton) {
      pushInteractionEvent(
        'Button',
        linkedButton.dataset.layerContext || image.dataset.layerContext,
        linkedButton.innerText || image.alt,
      );
      return;
    }

    pushInteractionEvent('Image', image.dataset.layerContext, image.alt);
  });
}

function trackLink(link) {
  link.addEventListener('click', () => {
    pushInteractionEvent('Links', link.dataset.layerContext, link.innerText);
  });
}

function trackFilter(filter) {
  const eventName = ['INPUT', 'SELECT'].includes(filter.tagName) ? 'change' : 'click';

  filter.addEventListener(eventName, () => {
    const activeFilterLabel = filter.dataset.layerLabel
      || filter.value
      || filter.innerText;

    pushInteractionEvent('Filter', filter.dataset.layerContext, activeFilterLabel);
  });
}

function trackFooterLink(link) {
  link.addEventListener('click', () => {
    dataLayer.push({
      event: 'footer',
      eventTimestamp: Date.now(),
      label: link.innerText.trim(),
    });
  });
}

function trackNewsletter(form) {
  form.addEventListener('newslettersuccess', () => {
    dataLayer.push({
      event: 'email_subscription',
      eventTimestamp: Date.now(),
    });
  });
}

export function initDataLayerInteractions() {
  window.dataLayer = window.dataLayer || [];

  const buttons = document.querySelectorAll('[data-layer-type="button"]');
  const images = document.querySelectorAll('[data-layer-type="image"]');
  const links = document.querySelectorAll('[data-layer-type="link"]');
  const filters = document.querySelectorAll('[data-layer-type="filter"]');
  const footerLinks = document.querySelectorAll('[data-layer-type="footerlink"]');
  const newsletterForm = document.querySelectorAll('[data-layer-type="newsletter"]');

  buttons.forEach(trackButton);
  images.forEach(trackImage);
  links.forEach(trackLink);
  filters.forEach(trackFilter);
  footerLinks.forEach(trackFooterLink);
  newsletterForm.forEach(trackNewsletter);
}
